<div>
  <h5> <b>{{ 'general.id' | translate }}</b> </h5>
  <p>{{ data.id }}</p>
</div>
